import { UnitTransferRequestStatusEnumType } from '__generated__/graphql';

export default function unitTransferStatusToReadable(status: UnitTransferRequestStatusEnumType): {
  label: string;
  color: string;
} {
  switch (status) {
    case UnitTransferRequestStatusEnumType.Draft:
      return { label: 'Draft', color: 'gray' };
    case UnitTransferRequestStatusEnumType.PendingTransfereeAcknowledgement:
      return { label: 'Awaiting Transferee', color: 'amber' };
    case UnitTransferRequestStatusEnumType.Submitted:
      return { label: 'Submitted', color: 'amber' };
    case UnitTransferRequestStatusEnumType.UnderReview:
      return { label: 'Under Review', color: 'amber' };
    case UnitTransferRequestStatusEnumType.PendingEscrowException:
      return { label: 'Pending Escrow Exception', color: 'amber' };
    case UnitTransferRequestStatusEnumType.ConditionsIssued:
      return { label: 'Conditions Issued', color: 'indigo' };
    case UnitTransferRequestStatusEnumType.PendingDocuments:
      return { label: 'Pending Documents', color: 'indigo' };
    case UnitTransferRequestStatusEnumType.DocumentsUnderReview:
      return { label: 'Documents Under Review', color: 'indigo' };
    case UnitTransferRequestStatusEnumType.DocumentsIncomplete:
      return { label: 'Documents Incomplete', color: 'red' };
    case UnitTransferRequestStatusEnumType.DocumentsVerified:
      return { label: 'Documents Verified', color: 'green' };
    case UnitTransferRequestStatusEnumType.PendingSignatures:
      return { label: 'Pending Signatures', color: 'indigo' };
    case UnitTransferRequestStatusEnumType.Executed:
      return { label: 'Executed', color: 'green' };
    case UnitTransferRequestStatusEnumType.ReadyForDis:
      return { label: 'Ready for DIS', color: 'green' };
    case UnitTransferRequestStatusEnumType.Rejected:
      return { label: 'Rejected', color: 'red' };
    case UnitTransferRequestStatusEnumType.Withdrawn:
      return { label: 'Withdrawn', color: 'gray' };
    case UnitTransferRequestStatusEnumType.TransfereeDeclined:
      return { label: 'Transferee Declined', color: 'red' };
    default:
      return { label: status, color: 'gray' };
  }
}
